import { render, staticRenderFns } from "./SSelectEducationalMajor.vue?vue&type=template&id=3caa2760"
import script from "./SSelectEducationalMajor.vue?vue&type=script&lang=js"
export * from "./SSelectEducationalMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports